module.exports = __webpack_public_path__ + "media/images/icon__smallInfoBox-d21769f573356f483cf593da9301a978.png";